import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";

import { get } from "../services";

Injectable({
    providedIn: 'root'
})

export class TokenInterceptorService implements HttpInterceptor {
    private readonly prefixChar = '$';
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token = get('token');
        //const token = 'eyJVc2VySWQiOiI4YjAxZDkzOS03MWI1LTRmMDMtODQ0NS0yNTUzYjJiMzc0ODEiLCJUZWFtSWQiOiIyIiwiUm9sZSI6IkFkbWluIn0=';
        const processed = this.processUrl(request.url);
        if (token) {
            request = request.clone({
                setHeaders: { 
                  'x-hunch-identity': token,
                //   'Authorization': 'Bearer '+ get('azureToken'),
                //   'Ocp-Apim-Subscription-Key': get('apiSubscriptionKey')
                },
                url: processed
            });
        }

        return next.handle(request);
    }

    private processUrl(url: string): string {
        if (url.startsWith(this.prefixChar)) {
          const splitted:string[] = url.split('/');
          const prefix:string = splitted[0] ? splitted[0] : '';
          const configKey:string = prefix.substring(1);
          const origin = get(configKey);
    
          if (!origin) {
            throw new Error(`There is no origin for prefix. ${url}`);
          }
    
          const paths = url.replace(prefix, origin);
    
          return `${paths}`;
        }
        return url;
      }
}